import { supabaseClient, useUser } from '@auth-v2';
import { useQuery } from '@tanstack/react-query';

import { fetchI18nMarkdown } from '@data';

const getI18nMarkdownKey = () => ['i18n-markdown'];

export const useI18nMarkdown = () => {
    const { data: user } = useUser();

    return useQuery({
        queryKey: getI18nMarkdownKey(),
        queryFn: () => fetchI18nMarkdown(supabaseClient),
        enabled: !!user?.id,
    });
};
